(function () {
    'use strict';

    angular
        .module('app.login')
        .component('sc3AccountDetailsModal', {
            templateUrl: 'app/login/account-details-modal.component.html',
            controller: AccountDetailsModalComponent,
            bindings: {
                close: '&',
                dismiss: '&',
                resolve: '<'
            }
        });

    AccountDetailsModalComponent.$inject = [];
    function AccountDetailsModalComponent() {
        var ctrl = this;
        ctrl.submit = submit;
        ctrl.$onInit = init;

        ///////////////////////

        function init() {
            ctrl.details = ctrl.resolve.details;
        };

        function submit() {
            if (ctrl.form.$valid)
                ctrl.close({ $value: ctrl.details });
        }
    }
})();